import LevelEditor from './LevelEditor';

function App() {
  return (
    <div className="App">
      <LevelEditor></LevelEditor>
    </div>
  );
}

export default App;
